import { useMemo } from "react";
import {
  CRYPTO_THEME_LABELS,
  DEAULT_HK_STOCK_THEME_SLUG,
  DEAULT_US_STOCK_THEME_SLUG,
  HOT_HK_STOCK_THEME_SLUG,
  HOT_US_STOCK_THEME_SLUG,
} from "@/src/componentsv1";
import { DashboardSortByTimeType, useTokenTopDashboard } from "@/src/hooks";
import {
  useTokensRanking,
  TokensQuestParams,
} from "@/src/hooks/useTokensRanking";
import { useStockDashboard } from "@/src/hooks/useStockDashboard";
import { TokenSortField, TokenSortOrder } from "@/src/types/api-params";
import { StockMarketEnum, StockSortField } from "@/src/features/api/openData";

export const useRecommendedData = (
  recommendedTab: "crypto" | "hk-stocks" | "us-stocks",
  sort?: DashboardSortByTimeType,
) => {
  // Crypto 热门数据
  const {
    data: { data: hotCryptos },
    isLoading: cryptoRequestAgentLoading,
  } = useTokensRanking({
    queryParams: {
      offset: 0,
      limit: 6,
      [TokensQuestParams.Enrich_With_Rating]: false,
      [TokensQuestParams.Sort_Field]: (sort || "day") as TokenSortField,
      [TokensQuestParams.Sort_Order]: "DESC" as TokenSortOrder,
    },
    enabled: recommendedTab === "crypto",
    gcTime: 1000 * 60,
    homeCategory: CRYPTO_THEME_LABELS.blueChip,
  });

  // Stock 热门数据
  const {
    data: { data: stockData },
    isLoading: stockRequestAgentLoading,
  } = useStockDashboard({
    pageSize: 6,
    sortFiled: StockSortField.MARKET_CAP,
    enabled: recommendedTab === "hk-stocks" || recommendedTab === "us-stocks",
    gcTime: 1000 * 60,
    market:
      recommendedTab === "hk-stocks" ? StockMarketEnum.HK : StockMarketEnum.US,
    themeKey:
      recommendedTab === "us-stocks"
        ? HOT_US_STOCK_THEME_SLUG
        : HOT_HK_STOCK_THEME_SLUG,
  });

  // Stock 趋势数据
  const {
    data: { data: stockTrending },
    isLoading: stockTrendingRequestAgentLoading,
  } = useStockDashboard({
    pageSize: 6,
    enabled: recommendedTab === "hk-stocks" || recommendedTab === "us-stocks",
    gcTime: 1000 * 60,
    market:
      recommendedTab === "hk-stocks" ? StockMarketEnum.HK : StockMarketEnum.US,
    themeKey:
      recommendedTab === "us-stocks"
        ? DEAULT_US_STOCK_THEME_SLUG
        : DEAULT_HK_STOCK_THEME_SLUG,
  });

  // Crypto 趋势项目
  const { data: trendingProjects, loading: hotXRequestAgentLoading } =
    useTokenTopDashboard({
      enabled: recommendedTab === "crypto",
      pageSize: 100,
    });

  const trendingProjectsDataSet = useMemo(() => {
    return (
      (trendingProjects || [])
        .filter((item) => item.token_symbol)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        .filter((i) => i.contract_address?.[0]?.id)
        .slice(0, 6)
    );
  }, [trendingProjects]);

  // 合并热门数据
  const { data: hotPageData, isLoading: hotPageDataLoading } = useMemo(() => {
    if (recommendedTab === "crypto") {
      return {
        data: hotCryptos,
        isLoading: cryptoRequestAgentLoading,
      };
    }
    if (recommendedTab === "hk-stocks" || recommendedTab === "us-stocks") {
      return {
        data: stockData,
        isLoading: stockRequestAgentLoading,
      };
    }
    return {
      data: [],
      isLoading: false,
    };
  }, [
    recommendedTab,
    hotCryptos,
    stockData,
    cryptoRequestAgentLoading,
    stockRequestAgentLoading,
  ]);

  return {
    hotPageData,
    hotPageDataLoading,
    trendingProjectsDataSet,
    hotXRequestAgentLoading,
    stockTrending,
    stockTrendingRequestAgentLoading,
  };
};
